import { Component, OnInit } from '@angular/core';
import { BreakdownsService } from 'src/app/services/http/breakdowns/breakdowns.service';

@Component({
  selector: 'app-extraction-breakdowns-solver',
  templateUrl: './extraction-breakdowns-solver.component.html',
  styleUrls: ['./extraction-breakdowns-solver.component.scss']
})
export class ExtractionBreakdownsSolverComponent implements OnInit {

  public data !: any;
  public loading: boolean = false;
  public displayedColumns : string[] = ['jour', 'nb', 'user_login'];
  public detail : any = [];

  constructor(private service: BreakdownsService) { }

  ngOnInit(): void {
  }

  onSubmit(){
    this.loading = true;
    this.service.getBreakdownSolverData().subscribe((data)=>{
      this.data = data;
    })
    this.service.getAllBreakdownSolver().subscribe((data)=>{
      data.forEach(breakdown =>{
        this.service.getBreakdownSavById(breakdown.breakdown_id.toString()).subscribe((breakDetail : any)=>{
          this.detail.push({"user_login" : breakdown.user_login, "state_time" : breakdown.state_time, "nom_installation" : breakDetail.nom_installation, "date_panne" : breakDetail.date_panne, "id_installation" : breakDetail.id_installation});
        })
      })
      this.loading = false;
    })


  }

}
